import { Routes } from '@angular/router';
import { sessionGuard } from './guards/session.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    data: {
      description: 'Portal exclusivo para clientes de Banco Santander que reúne en un mismo lugar beneficios únicos en servicios para el hogar.',
      title: 'Mundo Hogar | Conecta con tu hogar en un solo lugar',
    },
  },
  {
    path: 'benefits',
    loadChildren: () => import('./pages/benefits/benefits.routes'),
  },
  {
    path: 'credit-card',
    loadComponent: () => import('./pages/credit-card/credit-card.page').then(m => m.CreditCardPage),
    data: {
      description: 'Elige tu tarjeta ideal y accede a un mundo de beneficios en Mundo Hogar',
      title: 'Solicita una tarjeta de crédito Santander',
    },
  },
  {
    path: 'complaints-and-returns',
    loadComponent: () => import('./pages/complaints-and-returns/complaints-and-returns.page').then(m => m.ComplaintsAndReturnsPage),
    data: {
      description: 'Conoce cómo realizar devoluciones y reclamaciones en Mundo Hogar.',
      title: 'Devoluciones y reclamaciones',
    },
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage),
    data: {
      description: 'Contáctanos para resolver tus dudas o recibir asistencia en Mundo Hogar.',
      title: 'Contacto',
    },
  },
  {
    path: 'loading',
    loadComponent: () => import('./pages/loading/loading.page').then(m => m.LoadingPage),
  },
  {
    path: 'home-assistance',
    loadChildren: () => import('./pages/home-assistance/home-assistance.routes'),
  },
  {
    path: 'ecommerce',
    loadChildren: () => import('./pages/ecommerce/ecommerce.routes'),
  },
  {
    path: 'enrollment',
    loadChildren: () => import('./pages/enrollment/enrollment.routes'),
  },
  {
    path: 'leads-form',
    loadComponent: () => import('./pages/leads-form/leads-form.page').then(m => m.LeadsFormPage),
    data: {
      description: 'Formulario de contacto para clientes interesados en servicios y beneficios exclusivos de Mundo Hogar. Déjanos tus datos y un asesor especializado se pondrá en contacto contigo.',
      title: 'Solicitar financiamiento',
    },
  },
  {
    path: 'partner-leads-form',
    loadComponent: () => import('./pages/partner-leads-form/partner-leads-form.page').then(m => m.PartnerLeadsFormPage),
    data: {
      description: 'Formulario de contacto para clientes interesados en servicios y beneficios exclusivos de Mundo Hogar. Déjanos tus datos y un asesor especializado se pondrá en contacto contigo.',
      title: 'Solicitar financiamiento',
    },
  },
  {
    path: 'mortgage-simulator',
    loadChildren: () => import('./pages/mortgage-simulator/mortgage-simulator.routes'),
  },
  {
    path: 'moving',
    loadChildren: () => import('./pages/moving/moving.routes'),
  },
  {
    path: 'payment-gateway',
    canActivate: [sessionGuard],
    loadChildren: () => import('./pages/payment-gateway/payment-gateway.routes'),
  },
  {
    path: 'private-site',
    canActivate: [sessionGuard],
    loadChildren: () => import('./pages/private-site/private-site.routes'),
  },
  {
    path: 'project-simulator',
    loadChildren: () => import('./pages/project-simulator/project-simulator.routes'),
  },
  {
    path: 'remodeling',
    loadChildren: () => import('./pages/remodeling/remodeling.routes'),
  },
  {
    path: 'desarrolladores',
    loadChildren: () => import('./pages/real-estate/real-estate.routes'),
  },
  {
    path: 'survey',
    loadComponent: () => import('./pages/survey/survey.page').then(m => m.SurveyPage),
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./pages/warehouse/warehouse.routes'),
  },
  {
    path: 'what-is-mundo-hogar',
    loadComponent: () => import('./pages/what-is-mundo-hogar/what-is-mundo-hogar.page').then(m => m.WhatIsMundoHogarPage),
    data: {
      description: 'Conoce Mundo Hogar, el portal que reúne en un mismo lugar beneficios únicos en servicios para el hogar. Exclusivo para clientes Banco Santander.',
      title: 'Conoce los beneficios de Mundo Hogar',
    },
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
    data: {
      description: 'Página no encontrada en Mundo Hogar',
      title: 'Página no encontrada',
    },
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
    data: {
      description: 'Página no encontrada en Mundo Hogar',
      title: 'Página no encontrada',
    },
  },
];
